import { createMemo } from 'solid-js';
import { useCustomizationConfig } from '~/hooks/useCustomizationConfig';
import { CustomizationResponse } from '~/api/types/customisationData';

export function useScalekitWatermarkVisibility() {
  const { query, hasConfig } = useCustomizationConfig();

  const shouldShowWatermark = createMemo(() => {
    if (!hasConfig()) return false;
    if (query.isPending || query.isError) return false;

    const data = query.data as CustomizationResponse | undefined;
    const customBranding = data?.settings?.customBranding;

    return !customBranding;
  });

  return {
    shouldShowWatermark,
    isLoading: query.isPending
  };
}
